import { render, staticRenderFns } from "./recruit-temp.vue?vue&type=template&id=534a6da0&scoped=true&"
var script = {}
import style0 from "./recruit-temp.vue?vue&type=style&index=0&id=534a6da0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a6da0",
  null
  
)

export default component.exports